/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AuditInfoDto {
  /**
   * @minLength 1
   * @example "system"
   */
  createdBy: string;
  /** @format date-time */
  createdDate: string;
  /**
   * @minLength 1
   * @example "system"
   */
  lastModifiedBy: string;
  /** @format date-time */
  lastModifiedDate: string;
  /**
   * @format int64
   * @example 1
   */
  version: number;
}

export interface CustomerProjectionDto {
  /** @format uuid */
  customerId?: string;
  customerNumber?: string;
  displayName?: string;
  name?: string;
}

export interface DataElementAdditionCor1Dto {
  corSerial?: string;
  /** @format date */
  deregistrationDate?: string;
  licensePlate?: string;
  /** @format date */
  registrationDateFirst?: string;
  /** @format date */
  registrationDateLatest?: string;
  /** @default "COR_I" */
  type?: string;
}

export interface DataElementAdditionCor2Dto {
  corNumber?: string;
  licensePlate?: string;
  /** @format date */
  registrationDateFirst?: string;
  /** @format date */
  registrationDateLatest?: string;
  /** @default "COR_II" */
  type?: string;
}

export type DataElementAdditionDto = BaseDataElementAdditionDto &
  (
    | BaseDataElementAdditionDtoTypeMapping<"COR_I", DataElementAdditionCor1Dto>
    | BaseDataElementAdditionDtoTypeMapping<"COR_II", DataElementAdditionCor2Dto>
  );

export interface DataElementDto {
  addition?: DataElementAdditionDto;
  /** @format uuid */
  dataElementId: string;
  documentId: string;
  type: DataElementTypeDto;
}

export enum DataElementTypeDto {
  COR_I = "COR_I",
  COR_II = "COR_II",
  COC = "COC",
  ABE = "ABE",
  CERT = "CERT",
  CONTRACT = "CONTRACT",
  SALARY_STATEMENT = "SALARY_STATEMENT",
  ID_CARD = "ID_CARD",
  OTHER = "OTHER",
  CAR_KEY = "CAR_KEY",
  LICENSE_PLATE_FRONT = "LICENSE_PLATE_FRONT",
  LICENSE_PLATE_REAR = "LICENSE_PLATE_REAR",
  WARRANTY = "WARRANTY",
  RADIO_CODE = "RADIO_CODE",
}

export interface FieldValidationDto {
  code?: string;
  field?: string;
  message?: string;
}

export interface PrinterProjectionDto {
  displayName: string;
  name: string;
  /** @format uuid */
  printerId: string;
}

export interface ResourceCreatedDto {
  /** @format uuid */
  id?: string;
}

export interface StorageTransferCreateDto {
  /** @format uuid */
  correlationId: string;
  /** @format uuid */
  customerId: string;
  /** @minLength 1 */
  destinationCabinet: string;
  /** @format uuid */
  labelPrinterId: string;
  reason: StorageTransferReasonDto;
  /**
   * @minLength 1
   * @pattern ^((?![IOQ])[A-Z0-9]){17}$
   */
  vin: string;
}

export interface StorageTransferDataDto {
  /** @format uuid */
  correlationId: string;
  /** @format uuid */
  customerId: string;
  destinationCabinet?: string;
  items: DataElementDto[];
  /** @format uuid */
  labelPrinterId?: string;
  /** @format uuid */
  placementId?: string;
  reason: StorageTransferReasonDto;
  /** @format uuid */
  shipmentPackageId?: string;
  status: StorageTransferStatusDto;
  /** @format uuid */
  vehicleDataAcquisitionId?: string;
  /**
   * @minLength 1
   * @pattern ^((?![IOQ])[A-Z0-9]){17}$
   */
  vin: string;
}

export interface StorageTransferDto {
  audit: AuditInfoDto;
  data: StorageTransferDataDto;
}

export interface StorageTransferFinishDto {
  /** @minLength 1 */
  destinationCabinet: string;
  /** @format uuid */
  labelPrinterId: string;
}

export interface StorageTransferListDto {
  items: StorageTransferListItemDto[];
  /** @format int32 */
  totalPages: number;
}

export interface StorageTransferListItemDto {
  correlationId: string;
  /** Kunde */
  customer: string;
  /** @format uuid */
  customerId: string;
  /** @format uuid */
  id: string;
  reason: StorageTransferReasonDto;
  status: StorageTransferStatusDto;
  vin: string;
}

export enum StorageTransferReasonDto {
  SECURITY_CODE_ACQUISITION = "SECURITY_CODE_ACQUISITION",
  STORAGE_MERGE = "STORAGE_MERGE",
  STORAGE_MERGE_SECURITY_CODE_ACQUISITION = "STORAGE_MERGE_SECURITY_CODE_ACQUISITION",
}

export enum StorageTransferStatusDto {
  INITIALIZED = "INITIALIZED",
  FULFILLMENT_ASSIGNED = "FULFILLMENT_ASSIGNED",
  FULFILLMENT_FAILED = "FULFILLMENT_FAILED",
  FULFILLMENT_FINISHED = "FULFILLMENT_FINISHED",
  PLACEMENT_ASSIGNED = "PLACEMENT_ASSIGNED",
  VEHICLE_DATA_ACQUISITION_ASSIGNED = "VEHICLE_DATA_ACQUISITION_ASSIGNED",
  VEHICLE_DATA_ACQUISITION_FAILED = "VEHICLE_DATA_ACQUISITION_FAILED",
  WAITING_FOR_ACTION = "WAITING_FOR_ACTION",
  PLACEMENT_READY = "PLACEMENT_READY",
  FINISHED = "FINISHED",
}

export interface ValidationDto {
  fields?: FieldValidationDto[];
}

interface BaseDataElementAdditionDto {
  type: string;
}

type BaseDataElementAdditionDtoTypeMapping<Key, Type> = {
  type: Key;
} & Type;

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Storage Transfer Service by Kroschke
 * @version 0.1
 * @baseUrl /
 */
export class Sts<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Customer Projection
     * @name FindCustomers
     * @summary Find first 50 active customers
     * @request GET:/api/v1/projection/customer
     * @secure
     */
    findCustomers: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerProjectionDto[], any>({
        path: `/api/v1/projection/customer`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customer Projection
     * @name GetCustomerCabinets
     * @summary Get cabinets for a customer
     * @request GET:/api/v1/projection/customer/{id}/cabinets
     * @secure
     */
    getCustomerCabinets: (id: string, params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/api/v1/projection/customer/${id}/cabinets`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Printer Projection
     * @name FindZebraPrinters
     * @summary Find first 50 ZEBRA printers
     * @request GET:/api/v1/projection/printer/zebra
     * @secure
     */
    findZebraPrinters: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PrinterProjectionDto[], any>({
        path: `/api/v1/projection/printer/zebra`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security Code Acquisition
     * @name GetStorageTransferList
     * @summary Get storage transfer overview list
     * @request GET:/api/v1/storage-transfer
     * @secure
     */
    getStorageTransferList: (
      query?: {
        /**
         * @format int32
         * @min 0
         * @default 0
         */
        page?: number;
        /**
         * @format int32
         * @min 0
         * @exclusiveMin true
         * @default 25
         */
        size?: number;
        q?: string;
        /**
         * One hour
         * @example "PT1H"
         */
        fromRelative?: string;
        /**
         * One day
         * @example "P1D"
         */
        toRelative?: string;
        /** @format date-time */
        fromAbsolute?: string;
        /** @format date-time */
        toAbsolute?: string;
        /** @format uuid */
        customerId?: string;
        /** @uniqueItems true */
        status?: StorageTransferStatusDto[];
      },
      params: RequestParams = {},
    ) =>
      this.request<StorageTransferListDto, any>({
        path: `/api/v1/storage-transfer`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security Code Acquisition
     * @name CreateStorageTransfer
     * @summary Creates a new storage transfer
     * @request POST:/api/v1/storage-transfer
     * @secure
     */
    createStorageTransfer: (data: StorageTransferCreateDto, params: RequestParams = {}) =>
      this.request<ResourceCreatedDto, any>({
        path: `/api/v1/storage-transfer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security Code Acquisition
     * @name ValidateStorageTransfer
     * @summary Validates storage transfer create dto
     * @request POST:/api/v1/storage-transfer/validation
     * @secure
     */
    validateStorageTransfer: (data: StorageTransferCreateDto, params: RequestParams = {}) =>
      this.request<ValidationDto, any>({
        path: `/api/v1/storage-transfer/validation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security Code Acquisition
     * @name GetStorageTransfer
     * @summary Get storage transfer detail data
     * @request GET:/api/v1/storage-transfer/{id}
     * @secure
     */
    getStorageTransfer: (id: string, params: RequestParams = {}) =>
      this.request<StorageTransferDto, any>({
        path: `/api/v1/storage-transfer/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Security Code Acquisition
     * @name FinishStorageTransfer
     * @summary Finish storage transfer
     * @request PUT:/api/v1/storage-transfer/{id}/finish
     * @secure
     */
    finishStorageTransfer: (id: string, data: StorageTransferFinishDto, params: RequestParams = {}) =>
      this.request<StorageTransferDto, any>({
        path: `/api/v1/storage-transfer/${id}/finish`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
